import { Circle, Layer, Stage } from "react-konva";

interface LightOpStatusLegendComponentProps {
  isVisible: boolean;
}

const LightOpStatusLegendComponent: React.FC<
  LightOpStatusLegendComponentProps
> = ({ isVisible }) => {
  if (!isVisible) return null;
  const size = 20;
  const radius = size / 2;

  return (
    <div
      className="d-flex justify-content-center align-items-center gap-3 legend"
      style={{ marginBottom: "1rem", paddingTop: "2rem" }}
    >
      {/* <div className="d-flex gap-2">
        <div className="heatmap-legend d-flex flex-column align-items-center">
          <div style={{ position: "relative", width: "200px", height: "14px" }}>
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "3px",
                background:
                  "linear-gradient(to right, #e6fff2 0%, #b3ffd9 25%, #66ffb3 50%, #1acc8d 75%, #006644 100%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "25%",
                width: "1px",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.5)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                width: "1px",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.5)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "75%",
                width: "1px",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.5)",
              }}
            />
          </div>
          <div
            style={{
              position: "relative",
              width: "200px",
              fontSize: "0.7rem",
              color: "#333",
              marginTop: "4px",
            }}
          >
            <span style={{ position: "absolute", left: "-4px" }}>0</span>
            <span
              style={{
                position: "absolute",
                left: "25%",
                transform: "translateX(-50%)",
              }}
            >
              25
            </span>
            <span
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              50
            </span>
            <span
              style={{
                position: "absolute",
                left: "75%",
                transform: "translateX(-50%)",
              }}
            >
              75
            </span>
            <span style={{ position: "absolute", right: "-10px" }}>100</span>
          </div>
        </div>
      </div>

      <div
        style={{
          borderLeft: "1px solid #d9d9d9",
          height: "30px",
          margin: "0 20px",
        }}
      /> */}

      <div style={{ marginTop: "15px" }}>
        {/* Status indicators */}
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {/* On indicator */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <Stage width={size} height={size}>
              <Layer>
                <Circle x={radius} y={radius} radius={radius} fill="#016b47" />
              </Layer>
            </Stage>
            <span
              style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#333",
                textTransform: "uppercase",
              }}
            >
              On
            </span>
            {/* <span style={{ fontSize: "0.6rem", color: "#999" }}>Active</span> */}
          </div>

          {/* OFF indicator */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <Stage width={size} height={size}>
              <Layer>
                <Circle x={radius} y={radius} radius={radius} fill="#d9d9d9" />
              </Layer>
            </Stage>
            <span
              style={{
                fontSize: "0.7rem",
                fontWeight: 600,
                color: "#333",
                textTransform: "uppercase",
              }}
            >
              Off
            </span>
            {/* <span style={{ fontSize: "0.6rem", color: "#999" }}>Inactive</span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LightOpStatusLegendComponent;
